export default __webpack_public_path__ + "static/sport-video-poster-7bad9a3066b98800adb75b5c5b8da496.png";